import { SituacaoEnum } from '@/utils/enumerados';
import elementoVisivel from '../dom';

const VOLTAR_ETAPA = '[data-tour="voltar-etapa"]';

/**
 * Hint no item "Voltar Etapa" do menu Mais ações —
 * apenas na Manifestação de Intenção de Recurso, após o tour da fase.
 */
export default {
  id: 'voltar-etapa-manifestacao-hints',
  kind: 'hint',
  version: 1,
  label: 'Dica de Voltar Etapa',
  contexts: ['auction.situation'],
  situation: SituacaoEnum.MANIFESTACAO_INTENCAO_RECURSO,
  priority: 60,
  help: false,
  requires: ['manifestacao-intencao-recurso'],
  canQueue(ctx = {}) {
    if (!ctx.logged || !ctx.isCrier) return false;
    if (Number(ctx.situation) !== SituacaoEnum.MANIFESTACAO_INTENCAO_RECURSO) return false;
    return Boolean(ctx.voltarEtapaVisivel);
  },
  canStart(ctx = {}) {
    if (!ctx.logged || !ctx.isCrier) return false;
    if (Number(ctx.situation) !== SituacaoEnum.MANIFESTACAO_INTENCAO_RECURSO) return false;
    if (!ctx.voltarEtapaVisivel) return false;
    return Boolean(elementoVisivel(VOLTAR_ETAPA));
  },
  hints(ctx = {}) {
    if (!elementoVisivel(VOLTAR_ETAPA)) return [];

    const modalidade = ctx.auctionTypeName || 'processo';

    return [
      {
        id: 'voltar-etapa',
        element: VOLTAR_ETAPA,
        beacon: { side: 'left', align: 'center' },
        popover: {
          title: 'Voltar Etapa',
          description: `Use esta opção para retornar o(a) ${modalidade} a uma etapa anterior. Só fica disponível quando o relógio da manifestação não estiver vigente. Será pedida uma justificativa.`,
          side: 'left',
          align: 'start',
          buttonText: 'Entendi',
        },
      },
    ];
  },
};
